export function getApiUrl(): string {
  const url = process.env.NEXT_PUBLIC_API_URL || 'http://localhost:3333'
  return url.replace(/\/+$/, '')
}

export async function fetchApi(endpoint: string, options: RequestInit = {}) {
  const baseUrl = getApiUrl()
  const token = typeof window !== 'undefined' ? localStorage.getItem('cms_token') : null

  const headers: Record<string, string> = {
    'Accept': 'application/json',
    ...(options.headers as Record<string, string>),
  }

  if (token) {
    headers['Authorization'] = `Bearer ${token}`
  }

  if (!(options.body instanceof FormData) && !headers['Content-Type']) {
    headers['Content-Type'] = 'application/json'
  }

  const response = await fetch(`${baseUrl}/api/v1${endpoint.startsWith('/') ? '' : '/'}${endpoint}`, {
    ...options,
    headers,
  })

  const data = await response.json().catch(() => ({}))

  if (!response.ok) {
    if (response.status === 401 && typeof window !== 'undefined' && !endpoint.includes('/auth/login')) {
      localStorage.removeItem('cms_token')
      localStorage.removeItem('cms_user')
      window.location.href = '/login'
    }
    throw new Error(data.message || `API Error (${response.status})`)
  }

  return data
}
